export function verificarTipoPessoa(valor) {
  if (valor.length === 14) {
    return true
  }

  return false
}